/**
 * Created by Alexey on 20.03.17.
 */

define([
    "models/portalUser",
    "models/tcRestrictRole",
    "models/TableModel/projectReportTableModel",
], function (curUser, restrict, projectReportTM) {

    var menuArrayDefault = [{
        id: "default",
        value: "default",
        icon: "fa fa-users",
        details: "default"
    }];

    var sadminPart = {
        id: "settings_sadmin",
        value: APPLOCALE.mainMenu.settingsAdmin.name,
        icon: "fa fa-wrench",
        details: APPLOCALE.mainMenu.settingsAdmin.detail,
        hidden: false,
        data: [
            {
                id: "terminals",
                value: APPLOCALE.mainMenu.terminals.name,
                icon: "fa fa-calculator",
                details: APPLOCALE.mainMenu.terminals.detail
            },
            {
                id: "enterprise",
                value: APPLOCALE.mainMenu.enterprise.name,
                icon: "far fa-building",
                details: APPLOCALE.mainMenu.enterprise.detail
            },
            {
                id: "portalTemplate",
                value: APPLOCALE.mainMenu.portalTemplate.name,
                icon: "fa fa-globe",
                details: APPLOCALE.mainMenu.portalTemplate.detail
            },
            {
                id: "project",
                value: APPLOCALE.mainMenu.project.name,
                icon: "fa fa-globe",
                details: APPLOCALE.mainMenu.project.detail
            },
            {
                id: "tariffTypeChg",
                value: APPLOCALE.mainMenu.tarifftype.name,
                icon: "fa fa-clipboard-list",
                details: APPLOCALE.mainMenu.tarifftype.detail
            },
            {
                id: "ticketVarsEditor",
                value: APPLOCALE.mainMenu.sysvar.name,
                icon: "fa fa-code",
                details: APPLOCALE.mainMenu.sysvar.detail
            },
            {
                id: "toggleEditor",
                value: APPLOCALE.mainMenu.toggle.name,
                icon: "far fa-caret-square-down",
                details: APPLOCALE.mainMenu.toggle.detail
            },
            {
                id: "scriptManagement",
                value: APPLOCALE.mainMenu.script.name,
                icon: "far fa-file-code",
                details: APPLOCALE.mainMenu.script.detail
            }

        ]
    };

    var sadminPartFull = {
        id: "settings_sadmin_full",
        value: APPLOCALE.mainMenu.settings.name,
        icon: "fa fa-cogs",
        details: APPLOCALE.mainMenu.settings.detail,
        hidden: false,
        data: [
            {
                id: "bus",
                value: APPLOCALE.mainMenu.bus.name,
                icon: "fa fa-bus",
                details: APPLOCALE.mainMenu.bus.detail
            },
            {
                id: "terminalFirmware",
                value: APPLOCALE.mainMenu.terminal_firmware.name,
                icon: "fa fa-file",
                details: APPLOCALE.mainMenu.terminal_firmware.detail
            },
            {
                id: "users",
                value: APPLOCALE.mainMenu.users.name,
                icon: "fa fa-user",
                details: APPLOCALE.mainMenu.users.detail
            },
            {
                id: "system_log",
                value: APPLOCALE.mainMenu.syslog.name,
                icon: "fa fa-thermometer-half",
                details: APPLOCALE.mainMenu.syslog.detail
            },
            {
                id: "selectEnterprise",
                value: APPLOCALE.mainMenu.selEnterprise.name,
                icon: "fa fa-users",
                details: APPLOCALE.mainMenu.selEnterprise.detail
            },
            {
                id: "selectProjectReport",
                value: APPLOCALE.mainMenu.selProjectReport.name,
                icon: "fas fa-chart-bar",
                details: APPLOCALE.mainMenu.selProjectReport.detail
            },
            {
                id: "ticketTemplateEditor",
                value: APPLOCALE.mainMenu.ticket.name,
                icon: "fa fa-ticket-alt",
                details: APPLOCALE.mainMenu.ticket.detail
            },
            {
                id: "ticketTemplateManagement",
                value: APPLOCALE.mainMenu.ticket.nameNew,
                icon: "fa fa-ticket-alt",
                details: APPLOCALE.mainMenu.ticket.detailNew
            },
            {
                id: "formTemplates",
                value: APPLOCALE.mainMenu.cforms.name,
                icon: "fa fa-wrench",
                details: APPLOCALE.mainMenu.cforms.detail
            }
        ]
    };

    var adminPart = {
        id: "settings_admin",
        value: APPLOCALE.mainMenu.settings.name,
        icon: "fa fa-cogs",
        details: APPLOCALE.mainMenu.settings.detail,
        hidden: false,
        data: [
            {
                id: "bus",
                value: APPLOCALE.mainMenu.bus.name,
                icon: "fa fa-bus",
                details: APPLOCALE.mainMenu.bus.detail
            },
            {
                id: "users",
                value: APPLOCALE.mainMenu.users.name,
                icon: "fa fa-user",
                details: APPLOCALE.mainMenu.users.detail
            },
            {
                id: "selectEnterprise",
                value: APPLOCALE.mainMenu.selEnterprise.name,
                icon: "fa fa-users",
                details: APPLOCALE.mainMenu.selEnterprise.detail
            }
        ]
    };

    var enterpriseAdminPart = {
        id: "settings_admin",
        value: APPLOCALE.mainMenu.settings.name,
        icon: "fa fa-cogs",
        details: APPLOCALE.mainMenu.settings.detail,
        hidden: false,
        data: [
            {
                id: "users",
                value: APPLOCALE.mainMenu.users.name,
                icon: "fa fa-user",
                details: APPLOCALE.mainMenu.users.detail
            }
        ]
    };

    var help =  {
        id: "help",
        value: APPLOCALE.mainMenu.help.name,
        icon: "question-circle",
        details: APPLOCALE.mainMenu.help.detail
    };

    var menuArrayReport = [
        {
            id: "reportPassTransfers",
            value: APPLOCALE.mainMenu.reportPassTransfers.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportPassTransfers.detail,
        },
        {
            id: "reportPassTransfersModified",
            value: APPLOCALE.mainMenu.reportPassTransfers.name + " 1",
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportPassTransfers.detail + " 1",
        },
        {
            id: "reportPassTransfersExtended",
            value: APPLOCALE.mainMenu.reportPassTransfersExtended.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportPassTransfersExtended.detail,
        },
        {
            id: "reportControlPerm",
            value: APPLOCALE.mainMenu.reportControlPerm.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportControlPerm.detail,
        }, {
            id: "reportShiftPerm",
            value: APPLOCALE.mainMenu.reportShiftPerm.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportShiftPerm.detail,
        },
        {
            id: "reportTicketSales",
            value: APPLOCALE.mainMenu.reportTicketSales.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportTicketSales.detail,
        },
        {
            id: "reportRegisteredTrips",
            value: APPLOCALE.mainMenu.reportRegisteredTrips.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportRegisteredTrips.detail,
        },
        {
            id: "reportEspdPerm",
            value: APPLOCALE.mainMenu.reportEspdPerm.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportEspdPerm.detail,
        },
        {
            id: "reportLpdPerm",
            value: APPLOCALE.mainMenu.reportLpdPerm.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportLpdPerm.detail,
        },
        {
            id: "infoReportMonth",
            value: APPLOCALE.mainMenu.infoReportMonth.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.infoReportMonth.detail,
        },
        {
            id: "regularInfoReport",
            value: APPLOCALE.mainMenu.regularInfoReport.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.regularInfoReport.detail,
        },
        {
            id: "foregoneIncomeReport",
            value: APPLOCALE.mainMenu.foregoneIncomeReport.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.foregoneIncomeReport.detail,
        },
        {
            id: "fnReplacementReport",
            value: APPLOCALE.mainMenu.fnReplacementReport.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.fnReplacementReport.detail,
        },
        {
            id: "reportRouteAccounting",
            value: APPLOCALE.mainMenu.reportRouteWorkList.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportRouteWorkList.detail,
        },
        {
            id: "reportSyncTerminal",
            value: APPLOCALE.mainMenu.reportSyncTerminal.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportSyncTerminal.detail,
        },
        {
            id: "reportMIRTripsPerm",
            value: APPLOCALE.mainMenu.reportMIRTripsPerm.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportMIRTripsPerm.detail,
        },
        {
            id: "reportSummary",
            value: APPLOCALE.mainMenu.reportSummary.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportSummary.detail,
        },
        {
            id: "reportStops",
            value: APPLOCALE.mainMenu.reportStops.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportStops.detail,
        },
        {
            id: "reportStopsModified",
            value: APPLOCALE.mainMenu.reportStops.name + " 1",
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportStops.detail + " 1",
        },
        {
            id: "reportPassTraffic",
            value: APPLOCALE.mainMenu.reportPassTraffic.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportPassTraffic.detail,
        },
        {
            id: "reportBankCard",
            value: APPLOCALE.mainMenu.reportBankCard.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportBankCard.detail,
        },
        {
            id: "reportFiscalSummary",
            value: APPLOCALE.mainMenu.reportFiscalSummary.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportFiscalSummary.detail,
        },
        {
            id: "reportBankCardTotal",
            value: APPLOCALE.mainMenu.reportBankCardTotal.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reportBankCardTotal.detail,
        }
    ];

    var menuArraySuperAdmin = [
        {
            id: "mainEnterprise",
            value: APPLOCALE.mainMenu.enterprise.name,
            icon: "fa fa-users",
            details: APPLOCALE.mainMenu.enterprise.detail
        },
        {
            id: "tariffPlan",
            value: APPLOCALE.mainMenu.tarifPlans.name,
            icon: "fa fa-list",
            details: APPLOCALE.mainMenu.tarifPlans.detail
        },
        {
            id: "terminalsAll",
            value: APPLOCALE.mainMenu.terminalsAll.name,
            icon: "fa fa-calculator",
            details: APPLOCALE.mainMenu.terminalsAll.detail
        },
        {
            id: "tcards",
            value: APPLOCALE.mainMenu.cards.name,
            icon: "far fa-credit-card",
            details: APPLOCALE.mainMenu.cards.detail
        },
        {
            id: "transactions",
            value: APPLOCALE.mainMenu.transactions.name,
            icon: "fa fa-link",
            details: APPLOCALE.mainMenu.transactions.detail
        },
        {
            id: "report",
            value: APPLOCALE.mainMenu.reports.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reports.detail,
            data: [
                {
                    id: "reportsLoadTable",
                    value: APPLOCALE.mainMenu.reportsLoadTable.name,
                    icon: "fa fa-tasks",
                    details: APPLOCALE.mainMenu.reportsLoadTable.detail,
                },
                {
                    id: "reportsPlannedTable",
                    value: APPLOCALE.mainMenu.reportsPlannedTable.name,
                    icon: "fa fa-tasks",
                    details: APPLOCALE.mainMenu.reportsPlannedTable.detail,
                }
            ]
        }
    ];

//----------Admin------------------

    var menuArrayAdmin = [
        {
            id: "mainEnterprise",
            value: APPLOCALE.mainMenu.enterprise.name,
            icon: "fa fa-users",
            details: APPLOCALE.mainMenu.enterprise.detail
        },
        {
            id: "tariffPlan",
            value: APPLOCALE.mainMenu.tarifPlans.name,
            icon: "fa fa-list",
            details: APPLOCALE.mainMenu.tarifPlans.detail
        },
        {
            id: "terminalsAll",
            value: APPLOCALE.mainMenu.terminalsAll.name,
            icon: "fa fa-calculator",
            details: APPLOCALE.mainMenu.terminalsAll.detail,
        },
        {
            id: "tcards",
            value: APPLOCALE.mainMenu.cards.name,
            icon: "far fa-credit-card",
            details: APPLOCALE.mainMenu.cards.detail
        },
        {
            id: "transactions",
            value: APPLOCALE.mainMenu.transactions.name,
            icon: "fa fa-link",
            details: APPLOCALE.mainMenu.transactions.detail
        },
        {
            id: "report",
            value: APPLOCALE.mainMenu.reports.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reports.detail,
            data: [{
                id: "reportsLoadTable",
                value: APPLOCALE.mainMenu.reportsLoadTable.name,
                icon: "fa fa-tasks",
                details: APPLOCALE.mainMenu.reportsLoadTable.detail,
            }, {
                id: "reportsPlannedTable",
                value: APPLOCALE.mainMenu.reportsPlannedTable.name,
                icon: "fa fa-tasks",
                details: APPLOCALE.mainMenu.reportsPlannedTable.detail,
            }]
        }
    ];

    //----------Transporter------------------

    var menuArrayTransporter = [
        {
            id: "settings_admin",
            value: APPLOCALE.mainMenu.settings.name,
            icon: "fa fa-cogs",
            details: APPLOCALE.mainMenu.settings.detail,
            hidden: false,
            data: [
                {
                    id: "bus",
                    value: APPLOCALE.mainMenu.bus.name,
                    icon: "fa fa-bus",
                    details: APPLOCALE.mainMenu.bus.detail
                }
            ]
        },
        {
            id: "report",
            value: APPLOCALE.mainMenu.reports.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reports.detail,
            data: [
                {
                    id: "reportsLoadTable",
                    value: APPLOCALE.mainMenu.reportsLoadTable.name,
                    icon: "fa fa-tasks",
                    details: APPLOCALE.mainMenu.reportsLoadTable.detail,
                }
            ]
        },

    ];


    var menuArrayUser = [
        // {
        //     id: "settings_user",
        //     value: APPLOCALE.mainMenu.settings.name,
        //     icon: "fa fa-cogs",
        //     details: APPLOCALE.mainMenu.settings.detail,
        //     hidden: false,
        //     data: [
        //         {
        //             id: "bus",
        //             value: APPLOCALE.mainMenu.bus.name,
        //             icon: "fa fa-bus",
        //             details: APPLOCALE.mainMenu.bus.detail
        //         }
        //     ]
        // },
        {
            id: "report",
            value: APPLOCALE.mainMenu.reports.name,
            icon: "fa fa-file-excel",
            details: APPLOCALE.mainMenu.reports.detail,
            data: [
                {
                    id: "reportPassTransfersModified",
                    value: APPLOCALE.mainMenu.reportPassTransfers.name + " 1",
                    icon: "fa fa-file-excel",
                    details: APPLOCALE.mainMenu.reportPassTransfers.detail + " 1",
                },
                {
                    id: "reportStopsModified",
                    value: APPLOCALE.mainMenu.reportStops.name + " 1",
                    icon: "fa fa-file-excel",
                    details: APPLOCALE.mainMenu.reportStops.detail + " 1",
                },
                {
                    id: "reportsLoadTable",
                    value: APPLOCALE.mainMenu.reportsLoadTable.name,
                    icon: "fa fa-tasks",
                    details: APPLOCALE.mainMenu.reportsLoadTable.detail,
                }
            ]
        },

    ];
//---------------------------------
    var uploadReport = function (datasource, user) {
        // Async get project reports
        return new webix.promise(function (resolve, reject) {
            var filterReports = [{operator: "filter", name: "project_id", value: user.portalUser.projectId}];

            datasource.getDatasource().getRecords(filterReports, function (response, reportData) {
                resolve(reportData);
            }, function (e) {
                console.error(e);
                $$("mainLayout").hideProgress();
                reject(e);
            });
        });
    };

//----------InitMenu---------------

    return {
        getDataArray: function (user, curLocale) {
            uploadReport(projectReportTM, user).then(function (projectReportConfig) {
                var projectReportConf = projectReportConfig;

                var tree = $$("app:menu");
                var parentId = "report";

                var getReportById = function (report) {
                    if (!report.report_file || !curReport) return null;
                    return (report.report_file === curReport.id) ? report : null;
                };

                for (var curReportId in menuArrayReport) {

                    var curReport = menuArrayReport[curReportId];
                    var configReport = projectReportConfig.find(getReportById);
                    //console.log(curReport);

                    if (configReport !== null && configReport !== undefined) {
                        switch (user.portalUser.role) {
                            case "superadmin" :
                                tree.add(curReport, 0, parentId);
                                break;
                            case "admin":
                                if (configReport.visible_admin === "Y")
                                    if (!tree.getItem(curReport.id))
                                        tree.add(curReport, 0, parentId);
                                break;
                            case "enterprise_admin":
                                if (configReport.visible_enterprise_admin === "Y")
                                    if (!tree.getItem(curReport.id))
                                        tree.add(curReport, 0, parentId);
                                break;
                            case "transporter" :
                                if (configReport.visible_operator === "Y")
                                    if (!tree.getItem(curReport.id))
                                        tree.add(curReport, 0, parentId);
                                break;
                            case "user":
                                break;
                        }
                    }
                }
                tree.refresh();

            }).catch(function (error) {
                console.log(error);
            });

            var result = [];

            //TODO for Armenia
            if(user.portalUser.projectId === "8a8ae59c8a03c9f9018ab1a8ecbd006d"){
                //remove Bus for now
                sadminPartFull.data.shift();
                adminPart.data.shift();
                menuArrayTransporter[0].data.shift();
            }
            var isAlpikaTransporter = restrict.restrictOperatorAlpika(curUser.portalUser);
            if (isAlpikaTransporter) {
                menuArrayTransporter.push({
                    id: "transactions",
                    value: APPLOCALE.mainMenu.transactions.name,
                    hidden: true,
                    icon: "fa fa-link",
                    details: APPLOCALE.mainMenu.transactions.detail
                });
            }

            switch (user.portalUser.role) {
                case "superadmin":
                    result = menuArraySuperAdmin;
                    result.push(sadminPart);
                    result.push(sadminPartFull);
                    break;
                case "admin":
                    result = menuArrayAdmin;
                    result.push(adminPart);
                    break;
                case "enterprise_admin":
                    result = menuArrayAdmin;
                    result.push(enterpriseAdminPart);
                    //result.push(adminPart);
                    break;
                case "transporter":
                    result = menuArrayTransporter;
                    break;
                case "user":
                    result = menuArrayUser;
                    break;
                default:
                    result = menuArrayDefault;
            }

            result.push(help);

            return result;
        }
    };

})
;
